if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        this.quantity = this.querySelector('quantity-input');

        // const debouncedOnChange = debounce((event) => {
        //   if (parseInt(event.target.value) === 0) {
        //     this.startQueue(event.target.dataset.index, parseInt(event.target.value));
        //   } else {
        //     this.validateQuantity(event);
        //   }
        // }, ON_CHANGE_DEBOUNCE_TIMER);

        const debouncedOnChange = debounce((event) => {
          const input = event.target;
          const value = parseInt(input.value);
          const available = parseInt(input.dataset.available || '9999');
        
          if (value > available) {
            console.error(`🛑 You tried to add ${value}, but only ${available} are available.`);
            input.setCustomValidity(`Only ${available} in stock.`);
            input.reportValidity();
            this.cleanErrorMessageOnType(event);
            return;
          } else {
            input.setCustomValidity('');
          }
        
          if (value === 0) {
            this.startQueue(input.dataset.index, value);
          } else {
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
      }

      // connectedCallback() {
      //   this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      //     if (
      //       event.source === 'quick-add' ||
      //       (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index))) ||
      //       (event.cartData.variant_id && !(event.cartData.variant_id === parseInt(this.dataset.index)))
      //     ) {
      //       return;
      //     }
      //     // If its another section that made the update
      //     this.onCartUpdate().then(() => {
      //       this.listenForActiveInput();
      //       this.listenForKeydown();
      //     });
      //   });
      // }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'quick-add') return;

          const cartItems = event.cartData?.items;
          const variantId = parseInt(this.dataset.index);

          if (cartItems && variantId) {
            const newQuantity = cartItems
              .filter((item) => item.id === variantId)
              .reduce((sum, item) => sum + item.quantity, 0);

            const input = this.input;
            if (input) {
              input.value = newQuantity;
              input.setAttribute('value', newQuantity);
            }
          } else {
            this.onCartUpdate().then(() => {
              this.listenForActiveInput();
              this.listenForKeydown();
            });
          }
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      get input() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        if (!this.classList.contains('hidden')) {
          this.input?.addEventListener('focusin', (event) => event.target.select());
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        this.input?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.input?.blur();
            this.isEnterPressed = true;
          }
        });
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          },
          { once: true }
        );
      }

      get sectionId() {
        if (!this._sectionId) {
          const bulkContainer = this.closest('.collection-quick-add-bulk');
          const bulkSectionId = bulkContainer?.dataset.sectionId || bulkContainer?.dataset.id;

          if (bulkSectionId) {
            this._sectionId = bulkSectionId;
          } else {
            const sectionWrapper = this.closest('section[id^="shopify-section-"]');
            this._sectionId = sectionWrapper?.id?.replace('shopify-section-', '') || this.dataset.sectionId || this.dataset.section;
          }
        }

        return this._sectionId;
      }

      onCartUpdate() {
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector(`#quick-add-bulk-${this.dataset.index}-${this.sectionId}`);
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      getSectionsUrl() {
        const url = new URL(window.location.href);
        return `${url.pathname}${url.search}`;
      }

      updateMultipleQty(items) {
        this.selectProgressBar().classList.remove('hidden');

        const ids = Object.keys(items);
        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.renderSections(parsedState, ids);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
          })
          .catch(() => {
            // Commented out for now and will be fixed when BE issue is done https://github.com/Shopify/shopify/issues/440605
            // e.target.setCustomValidity(error);
            // e.target.reportValidity();
            // this.resetQuantityInput(ids[index]);
            // this.selectProgressBar().classList.add('hidden');
            // e.target.select();
            // this.cleanErrorMessageOnType(e);
          })
          .finally(() => {
            this.selectProgressBar().classList.add('hidden');
            this.setRequestStarted(false);
          });
      }

      getSectionsToRender() {
        return [
          {
            id: `quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
            section: this.sectionId,
            selector: `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'CartDrawer',
            selector: '.drawer__inner',
            section: 'cart-drawer',
          },
        ];
      }

      renderSections(parsedState, ids) {
        const intersection = this.queue.filter((element) => ids.includes(element.id));
        if (intersection.length !== 0) return;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (section.section === 'cart-drawer') {
            sectionElement.closest('cart-drawer')?.classList.toggle('is-empty', parsedState.items.length.length === 0);
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;
          if (elementToReplace) {
            // elementToReplace.innerHTML = this.getSectionInnerHTML(
            //   parsedState.sections[section.section],
            //   section.selector
            // );
            const new_html = new DOMParser().parseFromString(parsedState.sections[section.section], 'text/html');
            const newContent = new_html.querySelector(section.selector);
            if (newContent) {
              elementToReplace.innerHTML = newContent.innerHTML;
            }
          }
        });

        if (this.isEnterPressed) {
          this.querySelector(`#Quantity-${this.lastActiveInputId}`).select();
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    }
  );
}